












import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'BrandMediaLogo',
  props: {
    alt: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
  },
})
